import React from "react";

/** Вопросы и ответы магазина приходят с бэкенда — тот же текст Visoria отдаёт поисковикам. */
function OtherStoreFaq({ items }) {
  if (!items?.length) {
    return null;
  }

  return (
    <section className="other-store-faq content-block-no-top-bottom-padding my-5" aria-label="Вопросы и ответы">
      <h3 className="my-2 text-center text-2xl overline decoration-sky-500 dark:text-white">
        Вопросы и ответы
      </h3>
      <div className="mx-auto max-w-3xl">
        {items.map((item) => (
          <details key={item.q} className="other-store-faq-item">
            <summary>{item.q}</summary>
            <p>{item.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}

export default OtherStoreFaq;
